import React from 'react';
import {RouteComponentProps} from 'react-router-dom';
import {getServicesMarketplacePublicClient} from 'utilities/graphql/client';
import GetProfileOverviewQuery, {
  GetProfileOverviewQueryData,
} from '../graphql/GetProfileOverviewQuery.graphql';
import {notifyException} from 'utilities/analytics/bugsnag';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';
import compose from '@shopify/react-compose';
import i18nArgs from '../locales';
import Profile from './Profile';
import {ProfileIndexSkeleton} from './ProfileIndexSkeleton';
import NotFound from '../../not-found';
import {producePageViewMonorailEvent} from 'sections/services-marketplace/experts/utilities/monorail';
import {MonorailPageIndicators} from 'sections/services-marketplace/experts/utilities/constants';

const client = getServicesMarketplacePublicClient();

interface OwnProps {}

type CombinedProps = OwnProps &
  RouteComponentProps<{expertSlug: string}> &
  WithI18nProps;

interface State {
  profile?: GetProfileOverviewQueryData.Profile;
}

class ProfileIndex extends React.Component<CombinedProps, State> {
  state: State = {
    profile: undefined,
  };

  componentDidMount() {
    client
      .query<{
        profile: GetProfileOverviewQueryData.Profile;
      }>({
        query: GetProfileOverviewQuery,
        variables: {
          handle: this.props.match.params.expertSlug,
        },
      })
      .then(res => {
        this.setState({profile: res.data.profile});
      })
      .catch(error => {
        notifyException({error});
      });

    producePageViewMonorailEvent({
      pageIndicator: MonorailPageIndicators.profileIndex,
    });
  }

  render() {
    const {profile} = this.state;

    if (profile === undefined) return <ProfileIndexSkeleton />;

    if (profile === null) return <NotFound />;

    return <Profile profile={profile} />;
  }
}

export default compose<OwnProps>(withI18n(i18nArgs))(ProfileIndex);
